import { render } from "./CURPInput.vue?vue&type=template&id=48cc6e78&scoped=true"
import script from "./CURPInput.vue?vue&type=script&lang=js"
export * from "./CURPInput.vue?vue&type=script&lang=js"

import "./CURPInput.vue?vue&type=style&index=0&id=48cc6e78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cc6e78"]])

export default __exports__